import { MainLayout } from '@/layouts/MainLayout'
import OpenPosition from '@/root/src/components/open-position'
import gssp from '@/utils/gssp'

const OpenPositionPage = ({ poolAddress }: { poolAddress: string }) => {
  return (
    <MainLayout>
      <OpenPosition poolAddress={poolAddress} />
    </MainLayout>
  )
}

export default OpenPositionPage

export const getServerSideProps = gssp(async (context, fetcher) => {
  const poolAddress = context.params?.['pool-address']

  if (!poolAddress) {
    return {
      redirect: {
        destination: '/liquidity/browse',
        permanent: false,
      },
    }
  }

  return {
    props: {
      poolAddress: poolAddress,
    },
  }
})
